import { gql } from '@apollo/client';
import { ImageFragment } from '../../fragments/image';
export const QUERY_FOOTER = gql`
  query QueryFooter {
    globalFooter {
      data {
        attributes {
          links {
            text
            url
            file {
              data {
                ...ImageFragment
              }
            }
          }
          stillHumanlogo {
            data {
              ...ImageFragment
            }
          }
          edwinGroupLogo {
            data {
              ...ImageFragment
            }
          }
          linkedinUrl
          facebookUrl
          twitterUrl
          instagramUrl
          copyright
        }
      }
    }
  }
  ${ImageFragment}
`;
